import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { YtdSummaryRequestDto } from "../../core/models/bcLedgers/ytdSummaryRequestDto";
import { CommissionProgramTierRequestDto } from "../../core/models/bcLedgers/commissionProgramTierRequestDto";
import { forkJoin } from "rxjs";
import { BcledgerFilterComponent } from "./components/bcledger-filter/bcledger-filter.component";
import { UserManagementService } from "../../core/services/user-management.service";
import { JniToastrService } from "../../core/services/jni-toastr.service";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { BcledgerService } from "../../core/services/bcledger.service";
import { LoaderService } from "../../core/services/loader.service";
import { SharedService } from "../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { TotalBclegderComponent } from "./components/total-bclegder/total-bclegder.component";
import { YearToDateSummaryComponent } from "./components/year-to-date-summary/year-to-date-summary.component";
import { CommisionProgramTierComponent } from "./components/commision-program-tier/commision-program-tier.component";
import { Employee } from "../../core/models/profile/employee";

import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { CommissionProgramTierData } from "../../core/models/bcLedgers/commissionProgramTierDataDto";
import { BCLedgerTotalData } from "../../core/models/bcLedgers/bcLedgerTotalDataDto";
import { YtdSummaryData } from "../../core/models/bcLedgers/ytdSummaryDataDto";
import { BCLedgerFilter } from "../../core/models/bcLedgers/bclegderfilter";

@UntilDestroy()
@Component({
  selector: "jni-bcledger",
  templateUrl: "./bcledger.component.html",
  styleUrls: ["./bcledger.component.scss"],
  imports: [
    CommonModule,
    BcledgerFilterComponent,
    TotalBclegderComponent,
    YearToDateSummaryComponent,
    CommisionProgramTierComponent,
  ],
})
export class BcledgerComponent implements AfterViewInit, OnInit {
  current = new Date().toISOString();
  userStatus = "";
  bcList: Employee[] = [];
  commissionProgramTierList!: CommissionProgramTierData[];
  totalBcLegderLists: BCLedgerTotalData[] = [];
  ytdSummaryList: YtdSummaryData[] = [];
  bcLedgerFilter: BCLedgerFilter = {} as BCLedgerFilter;

  @ViewChild("filter", { static: false })
  filter!: BcledgerFilterComponent;

  constructor(
    private _loginService: UserManagementService,
    private _bcledgerService: BcledgerService,
    private _toastr: JniToastrService,
    private _loader: LoaderService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.getAllEmployee();
    this.getBcUser();
    //this.getDataFromSession();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  bcLedgerFilters!: BCLedgerFilter;

  ngAfterViewInit() {
    if (
      this.bcLedgerFilters &&
      Object.keys(this.bcLedgerFilters).length !== 0
    ) {
      this.filter.patchDate(
        this.bcLedgerFilters?.fromDate ?? "",
        this.bcLedgerFilters?.toDate ?? ""
      );
    }
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  // private getDataFromSession() {
  //   const bcLedgerFilter = JSON.parse(
  //     sessionStorage.getItem(`bcLedgerFilter`) || '[]'
  //   );
  //   this.bcLedgerFilters = bcLedgerFilter;
  //   const commissionProgramTierList = JSON.parse(
  //     sessionStorage.getItem(`commissionProgramTierList`) || '[]'
  //   );
  //   const totalBcLegderLists = JSON.parse(
  //     sessionStorage.getItem(`totalBcLegderLists`) || '[]'
  //   );
  //   const ytdSummaryList = JSON.parse(
  //     sessionStorage.getItem(`ytdSummaryList`) || '[]'
  //   );
  //   if (bcLedgerFilter) {
  //     this.bcLedgerFilter = bcLedgerFilter;
  //   }
  //   if (commissionProgramTierList) {
  //     this.commissionProgramTierList = commissionProgramTierList;
  //     this.commissionProgramTierList.sort((a, b) =>
  //       a.CommissionTierNumber > b.CommissionTierNumber ? 1 : -1
  //     );
  //   }
  //   if (totalBcLegderLists) {
  //     this.totalBcLegderLists = totalBcLegderLists;
  //   }
  //   if (ytdSummaryList) {
  //     this.ytdSummaryList = ytdSummaryList;
  //   }
  // }

  convertStringToDate(dateInString: string) {
    if (dateInString == "") {
      return new Date();
    }
    return new Date(dateInString);
  }

  getAllEmployee() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userStatus = res.data.userRole;
      });
  }

  getBcUser() {
    this._bcledgerService
      .getAllEmployees()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.bcList = res.data;
        },
      });
  }
  getBcLedgerFormData(bcLedgerFilter: BCLedgerFilter) {
    this._loader.setLoaderState(true);
    this.bcLedgerFilter = { ...bcLedgerFilter };
    const bcLedgerTotalPayload = {
      BrandingConsultantID: bcLedgerFilter.brandingConsultantID ?? "",
      FromDate: bcLedgerFilter.fromDate ?? "",
      ToDate: bcLedgerFilter.toDate ?? "",
    };

    const ytdSummaryPayload: YtdSummaryRequestDto = {
      ...bcLedgerTotalPayload,
    };
    const commissionProgramTierPayload: CommissionProgramTierRequestDto = {
      ToDate: bcLedgerFilter.toDate ?? "",
    };

    forkJoin({
      bcLedgerTotal: this._bcledgerService.bcLedgerTotal(bcLedgerTotalPayload),
      ytdSummary: this._bcledgerService.ytdSummary(ytdSummaryPayload),
      commissionProgramTier: this._bcledgerService.commissionProgramTier(
        commissionProgramTierPayload
      ),
    }).subscribe({
      next: ({ bcLedgerTotal, ytdSummary, commissionProgramTier }) => {
        this._loader.setLoaderState(false);
        this.commissionProgramTierList =
          commissionProgramTier.data.Data?.sort(
            (a: CommissionProgramTierData, b: CommissionProgramTierData) =>
              a.CommissionTierNumber > b.CommissionTierNumber ? 1 : -1
          ) ?? [];
        this.totalBcLegderLists = bcLedgerTotal.data.Data ?? [];
        this.ytdSummaryList = ytdSummary.data.Data ?? [];
        // sessionStorage.setItem(
        //   `commissionProgramTierList`,
        //   JSON.stringify(this.commissionProgramTierList)
        // );
        // sessionStorage.setItem(
        //   `totalBcLegderLists`,
        //   JSON.stringify(this.totalBcLegderLists)
        // );
        // sessionStorage.setItem(
        //   `ytdSummaryList`,
        //   JSON.stringify(this.ytdSummaryList)
        // );
        // sessionStorage.setItem(
        //   `bcLedgerFilter`,
        //   JSON.stringify(this.bcLedgerFilter)
        // );
        if (bcLedgerTotal?.status?.toLowerCase() !== "success") {
          this._toastr.error(
            "BC Ledger",
            bcLedgerTotal.message ?? "BC Ledger Total Error"
          );
        }
        if (ytdSummary?.status?.toLowerCase() !== "success") {
          this._toastr.error(
            "YTD Summary",
            ytdSummary.message ?? "YTD Summary Error"
          );
        }
        if (commissionProgramTier.status?.toLowerCase() !== "success") {
          this._toastr.error(
            "Commission Program Tier",
            commissionProgramTier.message ?? "Commission Program Tier Error"
          );
        }
      },
      error: () => {
        this._loader.setLoaderState(false);
        this._toastr.error("BC Ledger", "Error in Fetching BC Ledger API");
      },
    });
  }
}
